import { Observable } from "rxjs";
import { ProcessLine } from ".";

export interface ARCData {
    OutCorrectedRatio: string;
    ActualDeviation: string;
    Pv1: string;
    Pv2: string;
    Timestamp: string;
    InitialRecipeRatio: string;
    Solution: string;
    State: string;
    Line: ProcessLine;
}

export interface ARCParsedData {
    outCorrectedRatio: number;
    actualDeviation: number;
    pv1: number;
    pv2: number;
    timestamp: number;
    initialRecipeRatio: number;
    solution: string;
    state: string;
    line: ProcessLine;
}


export enum ARCSolutions {
    BS = 'BS',
    BC = 'BC',
    ET = 'ET',
    IS = 'IS',
    AC = 'AC',
    SL = 'SL',
    RT = 'RT',
};

export interface ARCObserverModel {
    arcObservable: Observable<ARCParsedData>
}
// BC, BS, CL, BU, BR   -    INTB
// IS, ET, AC    -     TBCF

export enum ARCINTBSolutions {
    BS = 'BS',
    BC = 'BC',
    CL = 'CL',
    BU = 'BU',
    BR = 'BR'
};

export enum ARCTBCFSolutions {
    ET = 'ET',
    IS = 'IS',
    AC = 'AC',
    SL = 'SL',
    RT = 'RT',
};

export type ARCSolutionWithDoubleSolution  = ARCINTBSolutions & ARCTBCFSolutions